// import logo from './logo.svg';
// import './App.css';
//
// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }
//
// export default App;

// src/App.js
// import React, { useEffect, useState } from 'react';
// import { Container, Navbar, Button, Card } from 'react-bootstrap';
// import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import './App.css';
//
// // Additional components for routing
// const Home = () => {
//     const [message, setMessage] = useState('');
//
//     // Fetch the message from the backend API
//     const fetchMessageFromServer = () => {
//         fetch('/api/message')
//             .then((response) => response.json())
//             .then((data) => {
//                 setMessage(data.message);
//             });
//     };
//
//     // Load data from the server when the component is first rendered
//     useEffect(() => {
//         fetchMessageFromServer();
//     }, []);
//
//     // Handle button click: First show custom text, then reload data from the server
//     const handleClick = () => {
//         setMessage('Hello, React!'); // Show custom text
//         setTimeout(() => {
//             fetchMessageFromServer(); // Fetch data again from the server
//         }, 2000); // Wait for 2 seconds before reloading the data (optional delay)
//     };
//
//     return (
//         <Container className="mt-5">
//             <Card className="text-center">
//                 <Card.Header>Welcome</Card.Header>
//                 <Card.Body>
//                     <Card.Title>Message from the Backend</Card.Title>
//                     <Card.Text>{message}</Card.Text>
//                     <Button variant="primary" onClick={handleClick}>Click Me!</Button>
//                 </Card.Body>
//             </Card>
//         </Container>
//     );
// };
//
// // About component
// const About = () => {
//     return (
//         <Container className="mt-5">
//             <Card className="text-center">
//                 <Card.Header>About Us</Card.Header>
//                 <Card.Body>
//                     <Card.Text>This is an about page where you can learn more about our application.</Card.Text>
//                 </Card.Body>
//             </Card>
//         </Container>
//     );
// };
//
// function App() {
//     return (
//         <Router>
//             <div className="App">
//                 <Navbar bg="dark" variant="dark">
//                     <Container>
//                         <Navbar.Brand as={Link} to="/">NITHRA STAFFING</Navbar.Brand>
//                         <Navbar.Collapse className="justify-content-end">
//                             <Navbar.Text>
//                                 <Link to="/" style={{ color: 'white', marginRight: '10px' }}>Home</Link>
//                                 <Link to="/about" style={{ color: 'white' }}>About</Link>
//                             </Navbar.Text>
//                         </Navbar.Collapse>
//                     </Container>
//                 </Navbar>
//
//                 {/* Define Routes */}
//                 <Routes>
//                     <Route path="/" element={<Home />} />
//                     <Route path="/about" element={<About />} />
//                 </Routes>
//             </div>
//         </Router>
//     );
// }
//
// export default App;


import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { Container, Navbar, Form, FormControl, Dropdown, InputGroup } from 'react-bootstrap';
import { FaFilter, FaSearch } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
// import 'ag-grid-community/styles/ag-grid.css';
// import 'ag-grid-community/styles/ag-theme-alpine.css';
import './App.css';
import Sidebar from './components/Sidebar';
import Home from './components/Home';
import About from './components/About';
import Dashboard from './components/Dashboard';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import trackEmployee from './components/trackEmployee';
import fileUpload from './components/fileUpload';
import employeePaymentPromotion from './components/employeePaymentPromotion';
import employeePayment from './components/employeePayment';
import employeeLeads from './components/employeeLeads';
import tiruppurEmployeeLeads from './components/tiruppurEmployeeLeads';
import createEmployee from './components/create-employee';
import createEmployer from './components/create-employer';
import createEmployerVacancy from './components/create-employer-vacancy';
import createEmployerVacancyNew from './components/create-employer-vacancy-new';
import createBillVacancy from './components/create-bill-vacancy';
import chat from './components/chat';
import { fetchGetData } from './components/api';
import { fetchPostData } from './components/api'; // Import your common API file

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));
    if (!!isAuthenticated)
        fetchGetData('/pdf')

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user_id');
        setIsAuthenticated(false);
        window.location.href = '/login'; // Redirect to login
    };
    const [data, setData] = useState({ totalCompanies: 0, totalPaid: 0 });

    useEffect(() => {
        // Check authentication status on component mount
        const token = localStorage.getItem('token');
        setIsAuthenticated(!!token);
        const user_id = localStorage.getItem('user_id') ? localStorage.getItem('user_id') : 0;

        if (user_id) {
            const fetchData = async () => {
                try {
                    const requestData = {
                        user_id,
                    }
                    const response = await fetchPostData('/billing/executive/monthlySummary', JSON.stringify(requestData), {
                        'Content-Type': 'application/json',
                    });
                    if (response.success) {
                        setData(response.data); // assuming your API returns { status: true, data: { totalCompanies, totalPaid } }
                        // console.log(response.data)
                    }
                } catch (error) {
                    console.error('Summary fetch failed', error);
                }
            };

            fetchData(); // invoke the async function
        }
    }, []);

    return (
        <Router>
            <div className="App d-flex">
                {/* Render Sidebar and Navbar only for authenticated routes */}
                {isAuthenticated && <Sidebar />}
                <div className="content">
                    {isAuthenticated && (
                        <Navbar bg="dark" variant="dark">
                            <Container fluid>
                                <div className="d-flex align-items-center">
                                    <Navbar.Brand href="#">NITHRA STAFFING</Navbar.Brand>

                                    {/* Total 1 + Paid stacked vertically */}
                                    <div className="d-flex flex-column ms-3">
                                        <span className="text-white fw-bold">Total Company : {data.totalCompanies}</span>
                                        {/* <span className="text-white">Total Amount : 25000</span> */}
                                    </div>
                                    <div className="d-flex flex-column ms-3">
                                        <span className="text-success blink fw-bold">Total Amount : {data.totalPaid}</span>
                                    </div>

                                </div>
                                {/* Search Bar */}
                                {/*<Form className="d-flex mx-auto flex-grow-1">*/}
                                {/*    <InputGroup>*/}
                                {/*        <InputGroup.Text id="basic-addon1">*/}
                                {/*            <FaSearch />*/}
                                {/*        </InputGroup.Text>*/}
                                {/*        <FormControl*/}
                                {/*            type="search"*/}
                                {/*            placeholder="Search"*/}
                                {/*            className="me-2"*/}
                                {/*            aria-label="Search"*/}
                                {/*        />*/}
                                {/*        <InputGroup.Text id="basic-addon1">*/}
                                {/*            <FaFilter />*/}
                                {/*        </InputGroup.Text>*/}
                                {/*    </InputGroup>*/}
                                {/*</Form>*/}

                                {/* User Dropdown */}
                                <Dropdown align="end">
                                    <Dropdown.Toggle variant="outline-light" id="dropdown-basic">
                                        Username
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item href="#/profile">Profile</Dropdown.Item>
                                        <Dropdown.Item href="#/settings">Settings</Dropdown.Item>
                                        <Dropdown.Divider />
                                        <Dropdown.Item onClick={logout}>Logout</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Container>
                        </Navbar>
                    )}

                    {/* Define Routes */}
                    <Routes>
                        <Route path="/login"
                            element={<Login setIsAuthenticated={setIsAuthenticated} />} /> {/* Pass down setter */}
                        <Route path="/about" element={<About />} /> {/* Public route */}
                        <Route path="/" element={<ProtectedRoute component={Home} />} /> {/* Protected route */}
                        <Route path="/dashboard"
                            element={<ProtectedRoute component={Dashboard} />} /> {/* Protected route */}
                        <Route path="/track/employee"
                            element={<ProtectedRoute component={trackEmployee} />} /> {/* Protected route */}
                        <Route path="/file/upload"
                            element={<ProtectedRoute component={fileUpload} />} /> {/* Protected route */}
                        <Route path="/web/employee/payment/promotion"
                            element={<ProtectedRoute component={employeePaymentPromotion} />} /> {/* Protected route */}
                        <Route path="/web/employee/payment/employeePayment"
                        element={<ProtectedRoute component={employeePayment} />} />
                        <Route path="/web/employee/leads"
                            element={<ProtectedRoute component={employeeLeads} />} /> {/* Protected route */}
                        <Route path="/web/tiruppur/employee/leads"
                               element={<ProtectedRoute component={tiruppurEmployeeLeads} />} /> {/* Protected route */}
                        <Route path="/create/employee"
                            element={<ProtectedRoute component={createEmployee} />} /> {/* Protected route */}
                        <Route path="/create/employer"
                            element={<ProtectedRoute component={createEmployer} />} /> {/* Protected route */}
                        <Route path="/create/employer/vacancy"
                            element={<ProtectedRoute component={createEmployerVacancy} />} /> {/* Protected route */}
                        <Route path="/create/employer/vacancy/new"
                            element={<ProtectedRoute component={createEmployerVacancyNew} />} /> {/* Protected route */}
                        <Route path="/create/bill/vacancy"
                            element={<ProtectedRoute component={createBillVacancy} />} /> {/* Protected route */}
                        <Route path="/chat"
                            element={<ProtectedRoute component={chat} />} /> {/* Protected route */}
                        <Route path="*" element={<Navigate to="/login" />} /> {/* Redirect unknown routes */}
                    </Routes>
                </div>
            </div>
        </Router>
    );
}

export default App;
